/* eslint-disable react-refresh/only-export-components -- контекст и useCart в одном модуле */
import { useCartLogic } from "@/shared/hooks/useCartLogic";
import React, { createContext, useContext } from "react";

const CartContext = createContext<ReturnType<typeof useCartLogic> | null>(null);

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const cart = useCartLogic();
  return <CartContext.Provider value={cart}>{children}</CartContext.Provider>;
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used inside CartProvider");
  }
  return context;
};
